<template>
    <div>
        <el-dialog
           title="户型详情"
            :visible.sync="showDialog"
            width="1200px"
            @close="close">
            
            <div class="base-warp">
                <el-row class="project-detail">
                    <el-col class="project" :span="18" :offset="0">
                        <el-row class="head">
                            <el-col :span="12" :offset="0">
                                <div class="title">暂存内容</div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="title">线上内容</div>
                            </el-col>
                        </el-row>
                        
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    项目名
                                </div>
                                <div class="info">
                                    <span class="span" v-if="edit.project">{{edit.project.name}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    项目名
                                </div>
                                <div class="info">
                                    <span class="span" v-if="project.project">{{project.project.name}}</span>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    名称
                                </div>
                                <div class="info">
                                    <span class="span">{{edit.name}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    名称
                                </div>
                                <div class="info">
                                    <span class="span">{{project.name}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    价格
                                </div>
                                <div class="info">
                                    <p class="p">单价：{{edit.price}}元/㎡/月</p>
                                    <p class="p">总价：{{edit.total_price}}元/月</p>
                                    <p class="p">房租：押{{edit.deposit}}付{{edit.payMonth}}</p>
                                    <p class="p">免租期：{{edit.freeMonth}}个月</p>
                                    <p class="p">起租期：{{edit.starMonth}}个月</p>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    价格
                                </div>
                                <div class="info">
                                    <p class="p">单价：{{project.price}}元/㎡/月</p>
                                    <p class="p">总价：{{project.total_price}}元/月</p>
                                    <p class="p">房租：押{{project.deposit}}付{{project.payMonth}}</p>
                                    <p class="p">免租期：{{project.freeMonth}}个月</p>
                                    <p class="p">起租期：{{project.starMonth}}个月</p>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    费用
                                </div>
                                <div class="info">
                                    <p class="p">物业费：{{edit.propertyFee}}元/㎡</p>
                                    <p class="p">电费：{{edit.energyCharge}}元/度</p>
                                    <p class="p">水费：{{edit.waterRate}}元/方</p>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    价格
                                </div>
                                <div class="info">
                                    <p class="p">物业费：{{project.propertyFee}}元/㎡</p>
                                    <p class="p">电费：{{project.energyCharge}}元/度</p>
                                    <p class="p">水费：{{project.waterRate}}元/方</p>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    其他
                                </div>
                                <div class="info" v-if="edit.message">
                                    <p class="p">面积：总面积{{edit.message.area}}㎡·可用{{edit.message.usage}}㎡</p>
                                    <p class="p">入驻时间：{{edit.message.date}}</p>
                                    <p class="p">装修：{{edit.message.fitment}}</p>
                                    <p class="p">空置中：{{edit.message.leisure?'是':'否'}}</p>
                                    <p class="p">适合经营：{{edit.message.manage}}</p>
                                    <p class="p">配套：{{edit.message.mating}}</p>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    其他
                                </div>
                                <div class="info" v-if="project.message">
                                    <p class="p">面积：总面积{{project.message.area}}㎡·可用{{project.message.usage}}㎡</p>
                                    <p class="p">入驻时间：{{project.message.date}}</p>
                                    <p class="p">装修：{{project.message.fitment}}</p>
                                    <p class="p">空置中：{{project.message.leisure?'是':'否'}}</p>
                                    <p class="p">适合经营：{{project.message.manage}}</p>
                                    <p class="p">配套：{{project.message.mating}}</p>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    图片
                                </div>
                                <div class="info" v-if="edit.imgs">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in edit.imgs" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="edit.imgs"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    图片
                                </div>
                                <div class="info" v-if="project.imgs">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in project.imgs" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="project.imgs"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="log" :span="6" :offset="0">
                        <div class="head">
                            <p class="title">记录</p>
                        </div>
                        <div class="timeline">
                            <el-timeline :reverse="reverse" timestamp="2018/4/12" placement="top">
                                <el-timeline-item
                                v-for="(log, index) in logs"
                                :key="index"
                                icon="el-icon-more"
                                type="primary">
                                    <el-card>
                                        <p>{{log.msg}}</p>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="foot">
                        <el-button v-if="project.status=='01'" type="warning" size="default" @click="soltout">下架</el-button>
                        <el-button v-if="edit.status=='02'" type="danger" size="default" @click="shownopass = true">不通过</el-button>
                        <el-button v-if="edit.status=='02'" type="primary" size="default" @click="pass">审核通过</el-button>
                    </div>
                </el-row>
            </div>
            <el-dialog
            width="400px"
            title="不通过理由"
            :visible.sync="shownopass"
            append-to-body>
                <el-form :model="form" ref="form" label-width="80px" :inline="false" size="normal">
                    <el-form-item label="填写理由">
                        <el-input type="textarea" v-model="form.marker"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="nopass">提交不通过</el-button>
                        <el-button @click="shownopass = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </el-dialog>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDialog: true,
            id: '',
            edit: '',
            project: '',
            logs: [],
            reverse: true,
            shownopass: false,
            form: {
                marker: '',
            },
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.getHouseType();
    },
    methods: {
        soltout() {
            this.$confirm('是否确定下架').then(
                confirm=>{
                    var params = {
                        id: this.id,
                    }
                    this.$api.HouseTypeSoltOut(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getHouseType();
                        }
                    )
                },
                cancel=>{}
            )
            
        },
        nopass() {
            var params = {
                id: this.id,
                marker: this.form.marker,
            }
            this.$api.HouseTypeNoPass(params).then(
                data=>{
                    this.message.success(data);
                    this.getHouseType();
                }
            )
        },
        pass() {
            this.$confirm('是否确定通过审核').then(
                confirm=>{
                    var params = {
                        id: this.id,
                    }
                    this.$api.HouseTypePass(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getHouseType();
                        }
                    )
                },
                cancel=>{}
            )
        },
        getHouseType() {
            var params = {
                id: this.id,
            }
            this.$api.getHouseTypeDetail(params).then(
                data=>{
                     console.log(data);
                    let {edit, house, logs} = data;
                    if(edit.message) edit.message = JSON.parse(edit.message);
                    if(edit.imgs) edit.imgs = JSON.parse(edit.imgs);
                    this.edit = edit;
                    if (house){
                        if(house.message) house.message = JSON.parse(house.message);
                        if(house.imgs) house.imgs = JSON.parse(house.imgs);
                    } else {
                        house = {};
                    }
                    this.project = house;
                    this.logs = logs;
                }
            )
        },
        close() {
             this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>